<template>
  <div id="app" class="full-layout">
    <router-view v-if="loading === false"></router-view>
  </div>
</template>

<script>
import communicationService from './services/PostMessageCommunation/CommunicationService';

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    loadData(initData) {
      this.$store.state.appConfig.is_embedded_in_mh_app = initData.is_embedded_in_mh_app;
      
      localStorage.setItem('token', initData.token);
      this.$store.state.kit.deepAncestryCoordinate = initData.deep_ancestry;
      this.$store.state.kit.kitId = initData.kit_id;
      this.$store.state.kit.default_ethnicity = initData.default_ethnicity;
      this.$store.state.kit.new_badge_menus = initData.new_badge_menus ? initData.new_badge_menus : '';
      this.$store.state.kit.isYouByDNAKit = initData.is_you_by_dna_kit ? 'You' : 'Other';
      this.$store.state.kit.gender = initData.gender;
      this.$store.state.kit.kitName = initData.is_you_by_dna_kit ? this.$tI_YO_G('Genetic Distance maps') : this.$tI_YO('Genetic Distance maps');

      this.$store.dispatch('region/fetchKitRegion', initData.default_ethnicity);
      this.loading = false;

      this.handleResize();
    },
    handleResize() {
      this.$store.state.appConfig.windowWidth = window.innerWidth;
      this.$store.state.appConfig.bodyHeight = document.body.scrollHeight - 75;
    },
  },
  beforeCreate() {
    window.addEventListener('resize', this.handleResize);
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  async mounted() { 
    let initData = await communicationService.getInitialData();
    if (!initData) {
      initData = { 
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMmQxMTdmNi04YTI0LTQ3NmYtYjgzYy1kMmU4NWU0YTU2ODA1NiIsInNlcnZpY2UiOiJTZXJ2aWNlVXNlciIsImp0aSI6IjJhNmQzNGIwLWE3YTEtNGI4Ni1iMjRhLTZkODBhOGM5YjAzNyIsImV4cCI6MTczMTM1MzMwMCwiaXNzIjoiU2VydmljZVVzZXIiLCJhdWQiOiJTZXJ2aWNlVXNlciJ9.ka9VZXPc1--EfRAr6G7nyErgjUmZ36s5lP5c15PsGM0', 
        deep_ancestry: 'test_scaled,0.0555,-0.193337,0.032332,-0.003553,-0.0333159,-0.013945,0.015276,0.010846,-0.005931,-0.009112,-0.023871,-0.010041,-0.002379,0.009909,-0.006922,-0.007955,-0.013951,-0.004181,-0.001006,-0.001501,-0.014474,-0.000247,-0.002835,-0.002651,-0.003473',
        kit_id: '0000',
        kit_name: 'test',
        default_ethnicity: 'ec58632b-7f7e-49f7-bd7e-5907e6b0844a', 
        language: 'en',
        gender: 'M',
        translate_url: '',
        translate_urls: {
          AncientDNAiFrame: 'https://www.myheritage.com/FP/API/get-dictionary.php?displayLang=EN&categoryName=AncientDNAiFrame&languageSet=2&json=1',
          AncientDNAIllustrative: 'https://www.myheritage.com/FP/API/get-dictionary.php?displayLang=EN&categoryName=AncientDNAIllustrative&languageSet=2&json=1',
        },
        is_you_by_dna_kit: true,
        is_embedded_in_mh_app: false,
      };
    }

    this.$store.dispatch('translate/loadTranslations', initData.translate_urls.AncientDNAIllustrative);
    await this.$store.dispatch('translate/loadTranslationsIframe', initData.translate_urls.AncientDNAiFrame);

    this.loadData(initData);
  },
};
</script>

<style>
#app {
  position: relative;
  min-height: 100%;
  height: 100vh;
}

</style>
